





























































/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator';
import path from 'path';
import api from '../util/api';
// @ts-ignore
import { Parallax, InfoAreas, ProfileCard, FullBgCard } from '@/client/components/_theme';
import Contact from '@/client/components/Contact.vue';
import CitySection from '@/client/components/CitySection.vue';
import Testimonials from '@/client/components/Testimonials.vue';
import GetInTouch from  '@/client/components/GetInTouch.vue';
import PassionsSectionHome from '@/client/components/PassionsSectionV2.vue';
import { ImageStrings } from '@/server/types';
import * as Constants from '@/client/components/constants';

@Component({
  components: {
    Parallax,
    InfoAreas,
    ProfileCard,
    FullBgCard,
    Contact,
    CitySection,
    Testimonials,
    GetInTouch,
    PassionsSectionHome,
  },
})
export default class Landing extends Vue {
  Constants = Constants;
  headerImage: string = require('@/client/assets/images/landscape-6.jpg');

  fish: ImageStrings = {
    image1: require('@/client/assets/images/landscape-basic.jpg'),
    image2: require('@/client/assets/images/landscape-5.jpg'),
    image3: require('@/client/assets/images/landscape-7.jpg'),
    image4: require('@/client/assets/images/landscape-4.jpg'),
  };
}
